import { render, staticRenderFns } from "./choice-question-component.vue?vue&type=template&id=e45d31ee&scoped=true&"
import script from "./choice-question-component.vue?vue&type=script&lang=ts&"
export * from "./choice-question-component.vue?vue&type=script&lang=ts&"
import style0 from "./choice-question-component.vue?vue&type=style&index=0&id=e45d31ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e45d31ee",
  null
  
)

export default component.exports